import { render, staticRenderFns } from "./AccettazioneConsensiListComponent.vue?vue&type=template&id=cb5c72f6"
import script from "./AccettazioneConsensiListComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneConsensiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports